import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';

import {
  Menu,
  CoreLink,
} from '@uncinc/react-drupal-core';

const SecondaryMenu = ({ onItemClick }) => {
  const currentPage = useSelector((state) => state.getIn(['router', 'location', 'pathname'], ''));

  return (
    <Menu id="secondary">
      {(items) => {
        return (
          <>
            {items.map((item) => {
              if (item) {
                const title = item.getIn(['link', 'title'], 'Untitled');
                const url = item.getIn(['link', 'url'], '');
                const active = item.getIn(['link', 'url']) === currentPage;
                const SecondaryMenuItemClassnames = c('SecondaryMenu__item', {
                  'SecondaryMenu__item--active': active,
                });

                return (
                  <div
                    key={title}
                    className={SecondaryMenuItemClassnames}
                  >
                    <CoreLink
                      className="SecondaryMenu__item__link"
                      to={url}
                      onClick={onItemClick}
                    >
                      <span className="SecondaryMenu__item__title">{title}</span>
                    </CoreLink>
                  </div>
                );
              }
            })}
          </>
        );
      }}
    </Menu>
  );
};

export default SecondaryMenu;
